const addToLocalDb = (id) => {
    const card = getStoredCart();
    const quantity = card[id];
    if (quantity) {
        card[id] = quantity + 1;
    } else {
        card[id] = 1;
    }
    localStorage.setItem("card", JSON.stringify(card));
};

const getStoredCart = () => {
    let card = {};
    const storedCard = localStorage.getItem("card");
    if (storedCard) {
        card = JSON.parse(storedCard);
    }
    return card;
};

const addCardQuantityToDB = (id) => {
    const card = getStoredCart();
    const quantity = card[id];
    if (quantity) {
        card[id] = quantity + 1;
    } else {
        card[id] = 1;
    }
    localStorage.setItem("card", JSON.stringify(card));
};

const removeCardQuantityToDB = (id) => {
    const card = getStoredCart();
    const quantity = card[id];

    if (!quantity) return;

    if (quantity === 1) {
        delete card[id];
    } else {
        card[id] = quantity - 1;
    }
    localStorage.setItem("card", JSON.stringify(card));
};

const removeSelectedCardToDB = (id) => {
    const storedCard = localStorage.getItem("card");
    if (storedCard) {
        const card = JSON.parse(storedCard);
        if (id in card) {
            delete card[id];
            localStorage.setItem("card", JSON.stringify(card));
        }
    }
};

const removeAllToDB = () => {
    localStorage.removeItem("card");
};

export { getStoredCart, addToLocalDb, removeSelectedCardToDB, removeAllToDB, addCardQuantityToDB, removeCardQuantityToDB };
